import withdrawalActionTypes from './withdrawals.types';

const INITIAL_STATE = {
    withdrawals: [],
    isFetching: false,
    isSubmitting: false,
    error: undefined,
    success: undefined
};

const withdrawalsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case withdrawalActionTypes.FETCH_WITHDRAWALS_START:
            return {
                ...state,
                isFetching: true
            };
        case withdrawalActionTypes.FETCH_WITHDRAWALS_SUCCESS:
            return {
                ...state,
                isFetching: false,
                withdrawals: action.payload
            };
        case withdrawalActionTypes.FETCH_WITHDRAWALS_FAILURE:
            return {
                ...state,
                isFetching: false,
                error: action.payload
            };
        case withdrawalActionTypes.CREATE_WITHDRAWAL_START:
            return {
                ...state,
                isSubmitting: true,
                error: undefined,
                success: undefined
            };
        case withdrawalActionTypes.CREATE_WITHDRAWAL_SUCCESS:
            return {
                ...state,
                isSubmitting: false,
                success: 'Withdrawal request submitted successfully!',
                withdrawals: [action.payload, ...state.withdrawals]
            };
        case withdrawalActionTypes.CREATE_WITHDRAWAL_FAILURE:
            return {
                ...state,
                isSubmitting: false,
                error: action.payload
            };
        default:
            return state;
    }
};

export default withdrawalsReducer;
